/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamAuthorDropdownQueryResponse,
  GetApiV1ExamAuthorDropdownQueryParams,
  GetApiV1ExamAuthorDropdown400,
  GetApiV1ExamAuthorDropdown401,
  GetApiV1ExamAuthorDropdown500,
} from "../../types/examSharedController/GetApiV1ExamAuthorDropdown.ts";

function getGetApiV1ExamAuthorDropdownUrl() {
  const res = { method: "GET", url: `/api/v1/exam/author-dropdown` as const };
  return res;
}

/**
 * @description Retorna a lista de autores (monitores, gestores e professores) para uso em componentes de seleção. Quando informado o companyId, retorna apenas pessoas com perfil correspondente naquela empresa; caso contrário, retorna monitores e corpo docente ativos. Aceita filtro por nome ou ID. **(Requer Authorization para autenticação)**
 * @summary Lista de autores para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/author-dropdown}
 */
export async function getApiV1ExamAuthorDropdown(
  params?: GetApiV1ExamAuthorDropdownQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamAuthorDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamAuthorDropdown400
      | GetApiV1ExamAuthorDropdown401
      | GetApiV1ExamAuthorDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamAuthorDropdownUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
